import React from 'react';
import Reveal from './Reveal';

const mono: React.CSSProperties = { fontFamily: "'JetBrains Mono', monospace" };

const POINTS = [
  {
    n: '01',
    title: 'Account-layer protection',
    body: 'Authorization is enforced at the account layer, where issuers already set policy.',
  },
  {
    n: '02',
    title: 'No L1 fork required',
    body: 'Runs alongside existing asset infrastructure. No base-chain or consensus upgrade required.',
  },
  {
    n: '03',
    title: 'No asset re-issuance',
    body: 'Strengthens existing asset programs without moving holders.',
  },
];

const WhatQSSNProtects: React.FC = () => (
  <section style={{ background: 'var(--bg)', padding: '7rem 1.5rem' }}>
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <Reveal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          borderTop: '1px solid var(--line)',
          paddingTop: '1.25rem',
          marginBottom: '3.5rem',
        }}
      >
        <span style={{ ...mono, fontSize: '.6875rem', letterSpacing: '.18em', textTransform: 'uppercase', whiteSpace: 'nowrap', color: 'var(--ink-3)' }}>01</span>
      </Reveal>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3rem 4rem' }}>
        <Reveal
          as="h2"
          style={{
            flex: '1 1 380px',
            margin: 0,
            fontWeight: 500,
            fontSize: 'clamp(2rem,3.4vw,3.1rem)',
            lineHeight: 1.05,
            letterSpacing: '-.02em',
            color: 'var(--ink)',
            textWrap: 'balance',
          } as React.CSSProperties}
        >
          Post-quantum protection for the actions that control regulated assets.
        </Reveal>

        <div style={{ flex: '1 1 420px' }}>
          <Reveal as="p" style={{ margin: '0 0 2rem', fontSize: '1.125rem', lineHeight: 1.6, color: 'var(--ink-2)' }}>
            QSSN protects the privileged operations digital asset issuers rely on to control issuance, settlement, and custody — the actions an attacker would target first.
          </Reveal>
          <Reveal style={{ borderTop: '1px solid var(--line)' }}>
            {POINTS.map((p) => (
              <div
                key={p.n}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '3rem 1fr',
                  gap: '1.25rem',
                  padding: '1.5rem 0',
                  borderBottom: '1px solid var(--line)',
                }}
              >
                <span style={{ ...mono, fontSize: '.8125rem', color: 'var(--accent)' }}>{p.n}</span>
                <div>
                  <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 500, color: 'var(--ink)' }}>{p.title}</h3>
                  <p style={{ margin: '.6rem 0 0', lineHeight: 1.6, color: 'var(--ink-2)' }}>{p.body}</p>
                </div>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default WhatQSSNProtects;
